import { render, staticRenderFns } from "./ProcesadoCliente.vue?vue&type=template&id=2867a4b0&"
import script from "@/Servicios/ProcesadoCliente.js?vue&type=script&lang=js&"
export * from "@/Servicios/ProcesadoCliente.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports